import { ProcessingMintRequest } from '@flipster/apis/v1/earn/types';
import { Datetime } from '@flipster/react/design-utils/datetime';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

const ProcessingMintRequestsContents = ({
  processingMintRequests,
}: {
  processingMintRequests: ProcessingMintRequest[];
}) => {
  return (
    <div className={stack()}>
      <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-2' })}>
        {processingMintRequests.length} pending
      </span>
      {processingMintRequests.map((request) => (
        <div
          key={`${request.confirmedAt}-${request.collateralCurrency}-${request.providerCurrency}`}
          className={stack({ gap: 2, py: 4 })}
        >
          <p className={css({ textStyle: 'Text/S/Monospace/Regular', color: 'content.default.level-4' })}>
            {request.side === 'MINT' &&
              `Mint ${request.providerCurrency} with ${numberFormatter(request.fromAmount, { precision: UsdtPrecision, withComma: true, toFixed: true })} ${request.collateralCurrency}`}
            {request.side === 'REDEEM' &&
              `Redeem ${numberFormatter(request.fromAmount, { precision: UsdtPrecision, withComma: true, toFixed: true })} ${request.providerCurrency} for ${request.collateralCurrency}`}
          </p>
          <p className={css({ textStyle: 'Text/S/Monospace/Regular', color: 'content.default.level-2' })}>
            {/* TODO: [sh] format이 이런 이유가 궁금하신가요?*/}
            {/* ref: https://www.figma.com/design/8bOVdAiCXUkWMyC8g7HdCk?node-id=10156-56681&m=dev#1454682398 */}
            <Datetime value={request.confirmedAt} format='MM/dd/yy HH:mm:ss' isUTC withUTCText />
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProcessingMintRequestsContents;
